import React, { Fragment, useRef } from 'react'
import PropTypes from 'prop-types'
import styled, { useTheme } from 'styled-components'
import { push } from 'connected-react-router'
import arraySort from 'array-sort'
import { getTruncatedString } from '../../../utils/string'
import ReactTooltip from 'react-tooltip'
import { logoutAndRedirect } from '../../../actions/auth'
import Organizations from '../../mini/Organizations'
import UserAvatar from '../../mini/UserAvatar'
import { P2 } from '../../styled/typography/typography'
import { useSelector } from 'react-redux'

const GuardianStyles = styled.div`
  display: block;
  padding: 20px 0;
  text-align: center;
  border-top: 1px solid rgb(151, 151, 151, .21);

  &:hover {
    cursor: pointer;
  }

  p {
    color: black;
    opacity: 1;
  }
`

const UserMenu = ({ dispatch, auth, organizationId }) => {
  const overflowMenu = useRef(null)
  const guardianUser = useSelector(state => state.auth.user.guardian_user)
  const disallowLeavingOrg = useSelector(state => state.loom.active)
  const theme = useTheme()

  const handleGuardianLobbyReturn = () => {
    dispatch(push('/guardianlobby'))
  }

  const getUserOrganization = (user, organizationId) => {
    return user
      ? user.organizations.find(function (org) {
          return org.id === organizationId
        })
      : { name: '' }
  }

  const getUserOrganizations = (user, organizationId) => {
    return user
      ? user.organizations.filter(org => org.id !== organizationId)
      : []
  }

  const logout = () => {
    dispatch(logoutAndRedirect())
  }

  const onSettingsClick = e => {
    e.stopPropagation() // prevent from bubbling up to route to profile
    dispatch(push(`/profile/${auth.user.id}/settings`))
  }

  const onOverflowClick = () => {
    dispatch(push(`/profile/${auth.user.id}`))
  }

  const onOverflowMouseOver = () => {
    overflowMenu.current.classList.add('active')
  }

  const onOverflowMouseOut = () => {
    overflowMenu.current.classList.remove('active')
  }

  const org = getUserOrganization(auth.user, organizationId)
  const userOrgs = getUserOrganizations(auth.user, organizationId)

  return (
    <Fragment>
      <div
        className="overflow"
        onMouseOver={onOverflowMouseOver}
        onMouseOut={onOverflowMouseOut}
      >
        <UserAvatar
          size={38}
          borderRadius={5}
          displayTooltip={false}
          photoUrl={auth.user.photo.url}
          isMentor={auth.isMentor}
          clickHandler={onOverflowClick}
        />
      </div>
      <div
        className={`overflow-menu ${
          auth.user.organizations.length === 1 ? 'one-organization' : ''
        }`}
        id="overflowMenu"
        ref={overflowMenu}
        onMouseOver={onOverflowMouseOver}
        onMouseOut={onOverflowMouseOut}
      >
        <div className="pointer-container">
          <div className='pointer'/>
        </div>
        <div className={`welcome welcome-${theme.style}`}>
          <UserAvatar
            size={64}
            borderRadius={10}
            photoUrl={auth.user.photo.url}
            isMentor={auth.isMentor}
            clickHandler={onOverflowClick}
          />
          <div
            className={
              auth.user.photo.url ? 'user-info with-photo' : 'user-info'
            }
            onClick={onOverflowClick}
          >
            <div className="user-name">
              <div onClick={onOverflowClick}>
                {getTruncatedString(auth.userName, 40)}
                {!guardianUser &&
                  <div className={`gear gear-${theme.style}`} onClick={onSettingsClick}/>
                }
              </div>
            </div>
            <P2 className="current-org">{org ? org.name : ''}</P2>
          </div>
        </div>
        {auth.user.organizations.length > 1 && (
          <div className={`organizations-wrapper organizations-wrapper-${theme.style}`}>
            <Organizations
              organizations={arraySort(userOrgs, ['name'])}
              user={auth.user}
              dispatch={dispatch}
              disabled={disallowLeavingOrg}
            />
          </div>
        )}
        {guardianUser &&
          <GuardianStyles onClick={handleGuardianLobbyReturn}>
            <P2>← Return to student selection.</P2>
          </GuardianStyles>
        }
        <div className={`user-actions user-actions-${theme.style}`}>
          <div
            className={`quest-btn btn-c quest-btn-${theme.style} ${
              disallowLeavingOrg ? 'disabled' : ''
            }`}
            onClick={disallowLeavingOrg ? null : logout}
            id="userLogout"
            data-tip="Complete your recording before logging out"
            data-for="disallow-leaving-org-tooltip"
          >
            Sign Out
          </div>
        </div>
        {disallowLeavingOrg && (
          <ReactTooltip
            id="disallow-leaving-org-tooltip"
            effect="solid"
          />
        )}
      </div>
    </Fragment>
  )
}

UserMenu.propTypes = {
  dispatch: PropTypes.func,
  organizationId: PropTypes.number,
  auth: PropTypes.object
}

export default UserMenu
